<div class="fullcontainer">
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields</div>
  }
  @if (this.isServerError) {
    <div class="alert alert-danger">Something went wrong. Please try again later.</div>
  }
  @if (this.isSuccess) {
    <div class="alert alert-success">Quote was updated successfully</div>
  }
  <div class='sheet'>
    <h1 class='header'>Edit Quote - {{ this.quote.name }}</h1>
    <app-audit-line [data]='this.quote'></app-audit-line>

    <button class='btn btn-primary' type='button' (click)='this.createPDFFile();'>Export to PDF</button>&nbsp;
    <button class='btn btn-primary' type='button' (click)='this.emailPDF();'>Email PDF</button>

    <form method='post' (ngSubmit)='this.onSubmit()'>
      <app-quote-forms [account]='this.account' [site]='this.site' [quoteLines]='this.quoteLines' [quote]='this.quote'></app-quote-forms>
      <button type="submit" class="btn btn-success">Save</button>&nbsp;
      <button type="button" class="btn btn-danger" routerLink='/quoting'>Cancel</button>
    </form>
  </div>
</div>

